<template>
  <!-- 系统提示弹窗 -->
  <div v-show="show" id="system_tip" class="system_tip">
    <header ref="sysTipHead" class="system_tip_head">
      <svg-icon icon-class="warnPop" />
      <i class="el-icon-close" @click="closeDialog()" />
    </header>
    <main>
      <div class="process">
        <div class="title">
          <div class="title1">系统提示</div>
          <div class="title2">
            <span>提</span>
          </div>
        </div>
        <el-divider></el-divider>
        <el-input
          v-model="tips"
          type="textarea"
          :readonly="true"
          resize="none"
        />
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    tips: {
      type: String,
      default: ''
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  watch: {
    show: {
      handler(n) {
        // 重置位置
        const head = this.$refs.sysTipHead
        if (n && head) {
          const parent = head.parentNode
          parent.style.left = 'auto'
          parent.style.top = 'auto'
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.drag() // 拖拽
  },
  methods: {
    closeDialog() {
      this.close()
      this.$emit('update:show', false)
    },
    drag() {
      const header = this.$refs.sysTipHead
      const parent = header.parentNode
      let isdrag = false
      // 鼠标按下并移动（开始拖拽）
      header.onmousedown = function(evt) {
        console.log(isdrag)
        if (!isdrag) {
          isdrag = true
          if (evt.target.nodeName === 'I') {
            isdrag = false
            return
          }
          evt = evt || window.event
          // 在摁下时，记录摁下的位置
          // 摁下光标位置距离事件源对象的偏移量
          // offsetX,offsetY
          const ox = evt.offsetX
          const oy = evt.offsetY
          document.onmousemove = function(e) {
            e = e || window.event
            // 在拖拽的过程中不断改变#box的top,left
            parent.style.left = e.clientX - ox + 'px'
            parent.style.top = e.clientY - oy + 'px'
            if (e.preventDefault) {
              e.preventDefault()
            } else {
              e.returnValue = false
            }
          }
        } else {
          isdrag = false
          document.onmousemove = null
        }
      }
      // 鼠标松开（拖拽完成）
      document.onmouseup = function() {
        document.onmousemove = null
        isdrag = false
        // this.$nextTick(function() {
        //   document.onmousemove = null
        //   isdrag = false
        // })
      }
      // // 鼠标离开（拖拽完成）
      // document.onmouseout = function() {
      //   document.onmousemove = null
      // }
      // 按键盘（拖拽完成）
      document.onkeydown = function() {
        isdrag = false
        document.onmousemove = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "@/views/v8/module/css/common.scss";
@import '~@/styles/mixin.scss';

// 自定义系统提示弹窗
.system_tip {
  @include wh(400px, 250px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 5px;
  right: 5px;
  z-index: 99999;
  background: #fff;
  border: 2px solid #ddd;
  border-left: 5px solid #2b8df0;
  box-shadow: 4px 4px 6px 6px #aaaaaa63;
  header {
    font-size: 16px;
    line-height: 30px;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // padding: 0 10px;
    .svg-icon {
      width: 106px;
      height: 34px;
    }
    i {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #fff;
    }
    i:hover {
      cursor: pointer;
    }
  }
  main {
    flex: 1;
    border: 1px solid $border-gray;
    border-top: 0 none;
    margin-top: -16px;
    // overflow: auto;
    height: calc(100% - 24px);
    .process {
      height: 100%;
      .title {
        display: flex;
        align-items: center;
        .title1 {
          display: inline-block;
          padding-left: 20px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
        }
        .title2 {
          display: inline-block;
          text-align: center;
          margin-left: 8px;
          border-radius: 3px;
          background: #2b8df0;
          width: 19px;
          // height: 16px;
          span {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
          }
        }
      }
      .el-divider {
        width: 90%;
        margin: 5px 20px 10px 20px;
      }
      /deep/.el-textarea {
        @include wh(100%, calc(100% - 38px));
        .el-textarea__inner {
          @include wh(100%, 100%);
          border: 0 none;
          padding: 10px 10px 10px 30px;
          font-size: 14px;
          background: rgba(255, 255, 255, 0.85);
          // color: #2b8df0;
          color: #ee1b1b;
          line-height: 2;
        }
      }
    }
  }
}
</style>
